import { init, captureException, setTag, setUser } from '@sentry/browser';
import { Severity } from './errorLogging.types';
export const initializeErrorLogging = (configuration) => {
    if (configuration.dataSourceName) {
        init({
            dsn: configuration.dataSourceName,
            environment: configuration.environment ? configuration.environment : 'unknown',
            release: configuration.release,
            beforeSend: configuration.beforeSend,
            ignoreErrors: [
                /Object Not Found Matching Id:\d+/,
            ],
        });
    }
};
export const setLoggingTag = (tagKey, value) => {
    setTag(tagKey, value);
};
export const logException = (error, severity = Severity.Error, additionalInfo) => {
    const context = {
        level: severity,
        extra: additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : undefined,
    };
    if (error instanceof Error) {
        return captureException(error, context);
    }
    const e = new Error(error);
    return captureException(e, context);
};
export const logUnknownException = (error, severity = Severity.Error, fallbackMessage = 'An error has occurred', additionalInfo) => {
    if (error instanceof Error) {
        return logException(error, severity);
    }
    else if (error instanceof Object) {
        return logException(fallbackMessage, severity, {
            errorObj: JSON.stringify(error),
            additionalInfo,
        });
    }
    else {
        return logException(fallbackMessage, severity, additionalInfo);
    }
};
export const setErrorLoggingUser = (user) => {
    setUser(user);
};
//# sourceMappingURL=errorLogging.js.map